export default __webpack_public_path__ + "static/media/Create PO Products Template.accf12a0.xlsx";